import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { BookIcon, VolumeIcon, FileTextIcon, GraduationCapIcon, ArrowRightIcon, StarIcon, BriefcaseIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Sitemap } from '../components/Sitemap';
const FEATURED_RESOURCES = [{
  title: {
    en: "Beginner's Guide",
    ar: 'دليل المبتدئين'
  },
  description: {
    en: 'Start your English journey with our comprehensive guide for beginners',
    ar: 'ابدأ رحلة تعلم اللغة الإنجليزية مع دليلنا الشامل للمبتدئين'
  },
  icon: StarIcon,
  color: 'blue',
  href: '/resources/beginners-guide'
}, {
  title: {
    en: 'Business English',
    ar: 'الإنجليزية للأعمال'
  },
  description: {
    en: 'Professional vocabulary and phrases for workplace communication',
    ar: 'المفردات والعبارات المهنية للتواصل في مكان العمل'
  },
  icon: BriefcaseIcon,
  color: 'purple',
  href: '/resources/business-english'
}];
const RESOURCES = [{
  title: {
    en: 'Vocabulary Lists',
    ar: 'قوائم المفردات'
  },
  description: {
    en: 'Essential words with examples and pronunciation',
    ar: 'كلمات أساسية مع أمثلة والنطق'
  },
  icon: BookIcon,
  href: '/learn/vocabulary'
}, {
  title: {
    en: 'Grammar Guide',
    ar: 'دليل القواعد'
  },
  description: {
    en: 'Learn English grammar rules with clear explanations',
    ar: 'تعلم قواعد اللغة الإنجليزية مع شرح واضح'
  },
  icon: FileTextIcon,
  href: '/resources/grammar'
}, {
  title: {
    en: 'Pronunciation',
    ar: 'النطق'
  },
  description: {
    en: 'Master English sounds and improve your speaking',
    ar: 'أتقن أصوات اللغة الإنجليزية وحسن مهارة التحدث'
  },
  icon: VolumeIcon,
  href: '/resources/pronunciation'
}, {
  title: {
    en: 'Downloadable Worksheets',
    ar: 'أوراق عمل قابلة للتحميل'
  },
  description: {
    en: 'Practice exercises to improve your skills',
    ar: 'تمارين تطبيقية لتحسين مهاراتك'
  },
  icon: GraduationCapIcon,
  href: '/learn/practice'
}];
export function Resources() {
  const {
    isArabic
  } = useLanguage();
  return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-4325">
      <Sitemap currentPage={{
      en: 'Resources',
      ar: 'المصادر'
    }} data-id="element-4326" />
      <div className="max-w-7xl mx-auto" data-id="element-4327">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-4328">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-4329">
            {isArabic ? 'مصادر التعلم' : 'Learning Resources'}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-4330">
            {isArabic ? 'مجموعة شاملة من المصادر لمساعدتك في تعلم اللغة الإنجليزية' : 'A comprehensive collection of resources to help you learn English'}
          </p>
        </div>
        {/* Featured Resources */}
        <div className="mb-16" data-id="element-4331">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-4332">
            {isArabic ? 'المصادر المميزة' : 'Featured Resources'}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4333">
            {FEATURED_RESOURCES.map((resource, index) => <Link key={index} to={resource.href} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 overflow-hidden group" data-id="element-4334">
                <div className="p-6" data-id="element-4335">
                  <div className="flex items-center gap-4 mb-4" data-id="element-4336">
                    <div className={`p-3 rounded-lg ${resource.color === 'blue' ? 'bg-blue-100 dark:bg-blue-900/30' : 'bg-purple-100 dark:bg-purple-900/30'}`} data-id="element-4337">
                      <resource.icon className={`w-6 h-6 ${resource.color === 'blue' ? 'text-blue-600 dark:text-blue-400' : 'text-purple-600 dark:text-purple-400'}`} data-id="element-4338" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-4339">
                      {isArabic ? resource.title.ar : resource.title.en}
                    </h3>
                  </div>
                  <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-4340">
                    {isArabic ? resource.description.ar : resource.description.en}
                  </p>
                  <div className="flex items-center text-sm font-medium text-blue-600 dark:text-blue-400 group-hover:translate-x-1 transition-transform" data-id="element-4341">
                    <span data-id="element-4342">
                      {isArabic ? 'استكشف المورد' : 'Explore resource'}
                    </span>
                    <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-4343" />
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
        {/* All Resources */}
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-4344">
          {isArabic ? 'جميع المصادر' : 'All Resources'}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4345">
          {RESOURCES.map((resource, index) => <Link key={index} to={resource.href} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 p-6 group" data-id="element-4346">
              <div className="flex items-center gap-3 mb-4" data-id="element-4347">
                <div className="p-2 bg-gray-100 dark:bg-gray-700 rounded-lg" data-id="element-4348">
                  <resource.icon className="w-5 h-5 text-gray-600 dark:text-gray-300" data-id="element-4349" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-4350">
                  {isArabic ? resource.title.ar : resource.title.en}
                </h3>
              </div>
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-4351">
                {isArabic ? resource.description.ar : resource.description.en}
              </p>
              <div className="flex items-center text-sm font-medium text-blue-600 dark:text-blue-400 group-hover:translate-x-1 transition-transform" data-id="element-4352">
                <span data-id="element-4353">{isArabic ? 'عرض المورد' : 'View resource'}</span>
                <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-4354" />
              </div>
            </Link>)}
        </div>
      </div>
    </div>;
}